import { render } from "./panelData.vue?vue&type=template&id=a235acf4&scoped=true"
import script from "./panelData.vue?vue&type=script&lang=js"
export * from "./panelData.vue?vue&type=script&lang=js"

import "./panelData.vue?vue&type=style&index=0&id=a235acf4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a235acf4"

export default script